import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { NbIconModule } from '@nebular/theme';

import { MealItemPresentationComponent } from './meal-item-presentation.component';
import { OverlayMealItemPresentationComponent } from './overlay-meal-item-presentation/overlay-meal-item-presentation.component';

@NgModule({
  imports: [CommonModule, NbEvaIconsModule, NbIconModule],
  declarations: [
    MealItemPresentationComponent,
    OverlayMealItemPresentationComponent,
  ],
  exports: [
    MealItemPresentationComponent,
    OverlayMealItemPresentationComponent,
  ],
})
export class MealItemPresentationModule {}
